import { Component } from '@angular/core';

interface Testimonial {
  title: string;
  description: string;
  author: string;
}

@Component({
  selector: 'app-testimonials-redesign',
  templateUrl: './testimonials-redesign.component.html',
  styleUrls: ['./testimonials-redesign.component.scss']
})
export class TestimonialsRedesignComponent {

  testimonials: Testimonial[] = [
    {
      title: 'Althea Soft LTD is a leading healthcare technology company that provides a state-of-the-art tracking system for healthcare providers',
      description: 'Althea Soft LTDs platform allows us to easily and accurately monitor our patients symptoms, track medication usage, and manage other critical health data. With their innovative system, our healthcare team can identify potential issues early on, make more informed treatment decisions, and ensure better overall patient outcomes. Additionally, their built-in AI Assistance allows us to streamline our operations using hands-free voice commands and a highly direct interface with the system. This optimization drastically improves our daily workflow, while delivering superior outcomes, highly accurate risk predictions, and faster patient assessments. Althea Soft LTD is truly dedicated to improving healthcare through technology, and they are making a deeply meaningful impact on how we run our practice.',
      author: 'Filip Luis - Founder & CEO'
    },
    {
      title: 'The AltheaCare Platform has completely transformed how we manage our patient data.',
      description: 'Their cutting-edge platform allows our patients to easily track their own symptoms, medications, and vital signs from home. At the same time, it gives us the ability to remotely monitor their health in real time and step in early whenever necessary. By encouraging patient self-management and giving our team actionable data, they have proven to be a true leader in healthcare tracking. We’ve seen a massive improvement in patient outcomes, and it has allowed us to deliver the best possible care.',
      author: 'Sarah Taylor -  CEO'
    },
    {
      title: 'Althea Soft LTD has become an indispensable partner for our healthcare practice',
      description: 'Their platform enables our patients to track their health data in real-time, while allowing us to remotely monitor progress and intervene if necessary. The system is perfectly designed to improve patient outcomes by alerting our staff to warning signs early on, enabling early intervention. Their drive for innovation and commitment to using the latest technological advances directly helps our patients achieve their best possible health outcomes. These services are a critical resource for our everyday operations, and they truly position the company at the forefront of the healthcare tracking and monitoring industry.',
      author: 'Matt Lanning - CEO'
    }
  ];

  trackByAuthor(index: number, testimonial: Testimonial): string {
    return testimonial.author + index;
  }

}